<template lang="pug">
  div
    slot(:products="products")
</template>

<script>
  import vueProductSvc from '../services/vueProductSvc';

  export default {
    props: {
      productIds: {
        type: Array
      },

      productType: {
        type: String
      }
    },

    asyncComputed: {
      products() {
        if (this.productIds) {
          return vueProductSvc.getProductsById({ ids: this.productIds }).then(res => {
            return res.data.filter(prod => prod.status && prod.visible);
          });
        } else {
          return vueProductSvc.getProductsByType({ productType: this.productType }).then(res => {
            return res.data.filter(prod => prod.status && prod.visible);
          });
        }
      }
    }
  }
</script>
